/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */
const env = process.env.NODE_ENV
const isDesktop = typeof window.orientation === 'undefined'

export default config = Object.freeze({
    // Environments
    ENV: env,
    IS_PROD: env === 'production',
    IS_DEV: env === 'development',

    // Device
    IS_MOBILE: !isDesktop,
    IS_DESKTOP: isDesktop,

    // CSS class names
    CSS_CLASS: {
        FIRST_LOADED: 'is-first-loaded',
        LOADING: 'is-loading',
        READY: 'is-ready',
        LOADED: 'is-loaded',
        MOBILE: 'is-mobile',
        DESKTOP: 'is-desktop',
    },
})
